import { FC, ReactElement, memo } from 'react';
import { useIsMutating } from 'react-query';

import { FallbackedLayout } from '@/common/layouts';

import { ReferralLinksQueryKeys, useGetAllReferralLinksQuery } from '@/modules/Sites';

import { ReferralLinksListView } from './ReferralLinksListView';

interface Props {
  referralId: string;
  siteId: string;
  handleSetEditingListMode: (is?: true) => void;
}

export const ReferralLinksListContainer: FC<Props> = memo(({ referralId, siteId, handleSetEditingListMode }) => {
  const {
    data: referralLinksData,
    error: referralLinksError,
    isLoading: isReferralLinksLoading,
    isFetching: isReferralLinksFetching,
    isError: isReferralLinksError,
  } = useGetAllReferralLinksQuery(siteId, referralId)({
    enabled: !!referralId && !!siteId
  });

  const isEditAccountFetching = !!useIsMutating({
    mutationKey: [ReferralLinksQueryKeys.Edit, siteId, referralId],
    exact: true
  });

  return (
    <FallbackedLayout
      data={ referralLinksData }
      isLoading={ isReferralLinksLoading }
      isError={ isReferralLinksError }
      error={ referralLinksError }
    >
      {
        (referralLinks): ReactElement => (
          <ReferralLinksListView
            referralLinks={ referralLinks }
            disableControlButtons={ isEditAccountFetching || isReferralLinksFetching }
            handleSetEditingListMode={ () => handleSetEditingListMode(true) }
          />
        )
      }
    </FallbackedLayout>
  );
});
